/**
 * The amenity category RENDER ORDER — declared once, read by both surfaces.
 *
 * NOT the wire order and not alphabetical: it is `listing.v1.AmenityCategory`'s
 * own declaration order, which is how the vocabulary is curated (shared
 * facilities → unit features → appliances → building services). The public
 * detail page groups by it and the wizard's amenities picker groups by it, and
 * they must agree — an owner who ticks a box under "Appliances" and then sees
 * it filed under something else on the live listing has been told two things.
 *
 * It lives here, in the lib layer, for the same reason `amenityIcon` lives in
 * `@letsgethome/ui`: two private copies of an ordering drift the first time
 * either is edited, and nothing would go red when they did.
 *
 * `UNSPECIFIED` is absent by construction — a row that carried it would be a
 * vocabulary row with no category, which the column's CHECK forbids — so such
 * a row is simply not rendered rather than landing in an untitled group. Both
 * readers filter by membership of this list, so that is a property of the list
 * rather than a rule each of them has to remember.
 */
import type { AmenityCategoryName } from '@/shared/lib/types/listing';

export const AMENITY_CATEGORY_ORDER: readonly AmenityCategoryName[] = [
  'FACILITY',
  'FEATURE',
  'APPLIANCE',
  'SERVICE',
];
